module.exports = __webpack_public_path__ + "img/172220.92b537e8.png";